import {Injectable} from '@angular/core';
import {Email} from '../original-models/email.model';
import {Observable} from 'rxjs';
import {Password} from '../original-models/resent-password.model';
import {RequestsService} from '../services/requests.service';

@Injectable({ providedIn: 'root' })
export class RestoreDataService {

    constructor(
        protected readonly requestsService: RequestsService
    ) {}

    sendEmail(params: Email): Observable<string> {
        return this.requestsService.request('POST', `/account/password/`, params);
    }


    sendPassword(params: Password): Observable<string> {
        return this.requestsService.request('PUT', `/account/password/`, params);
    }
}
